import { createStyle } from '@gluestack-style/react';

export const AvatarGroup = createStyle({
  flexDirection: 'row-reverse',
  position: 'relative',
  _avatar: {
    ml: -10,
  },
});
